import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";

export const SaveQuoteLog = (quoteId, email, setLoading, setMessage, setQuoteSaved ) => {
    fetch(`/api/QuoteLog/SaveConsumerQuote?consumerEmailAddress=${email}&quoteLogID=${quoteId}`, {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
          'Content-Type': 'application/json'
        }
      })
        .then((res) => res.json())
        .then((data) => {
            setLoading(false);
            if(data){
                setMessage({status:'success', message:'Your quote has been saved'});
                setQuoteSaved(false);
            }
            else{
                setMessage({status:'error',message : 'Could not save your email address. Please try again'})
            }
        })
        .catch((error) => {
           setLoading(false);
           setMessage({status:'error',message : 'Could not save your email address. Please try again'})
        })
        .finally(() => {
          setLoading(false);
        });
}


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/SaveTermQuote/SaveQuoteLog.js